import { useState, useEffect } from 'react';

export default function ToggleLanguage({ index, onChange }) {
	return (
		<div className="toggle-language">
			{languageData.map((item) => (
				<div key={item.id}>
					<button
						type="button"
						className={index === item.val ? "active" : ""}
						onClick={() => onChange(item.val)}
					>
						{item.label}
					</button>
				</div>
			))}
		</div>
	);
}

const languageData = [
	{ id: 0, val: "en", label: "ENG" },
	{ id: 1, val: "ko", label: "KOR" },
];
